function findClientField(chamadoData) {
  if (chamadoData.createdByIdRef === 'Cliente') {
    return chamadoData.createdByClientId;
  }

  return chamadoData.createdByEmployeeId;
}

export default findClientField;
